// src/admin/hooks/useTags.js

import { useEffect, useState } from "react";
import { tagService } from "../services/tagService";

export default function useTags(search = "") {

    const [tags, setTags] = useState([]);
    const [loading, setLoading] = useState(true);
    const [deletingId, setDeletingId] = useState(null);
    const [saving, setSaving] = useState(false);

    useEffect(() => {

        const timeout = setTimeout(() => {
            fetchTags();
        }, 400);

        return () => clearTimeout(timeout);

    }, [search]);

    const fetchTags = async () => {
        try {

            setLoading(true);

            const data = await tagService.getTags(search);

            setTags(data.results || data || []);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const createTag = async (data) => {

        setSaving(true);

        try {
            await tagService.createTag(data);
            await fetchTags();
        } catch (error) {
            console.error(error);
        } finally {
            setSaving(false);
        }
    };

    const updateTag = async (id, data) => {

        setSaving(true);

        try {
            await tagService.updateTag(id, data);
            await fetchTags();
        } catch (error) {
            console.error(error);
        } finally {
            setSaving(false);
        }
    };

    const deleteTag = async (id) => {

        const confirmed = window.confirm(
            "Are you sure you want to delete this tag?"
        );

        if (!confirmed) return;

        try {

            setDeletingId(id);

            setTags(prev => prev.filter(t => t.id !== id));

            await tagService.deleteTag(id);

        } catch (error) {
            console.error(error);
        } finally {
            setDeletingId(null);
        }
    };

    return {
        tags,
        loading,
        saving,
        deletingId,

        fetchTags,
        createTag,
        updateTag,
        deleteTag,
    };
}